import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Paper,
  LinearProgress,
  Divider,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  EmojiEvents as TrophyIcon,
  Home as HomeIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import ReviewAnswersDialog from "./ReviewAnswersDialog";

const FinalScoreDialog = ({
  open,
  score,
  correctAnswers,
  totalQuestions,
  onClose,
  totalScore,
  sessionId,
  dayLabel,
  sectionLabel
}) => {
  const [openReview, setOpenReview] = useState(false);
  const percentage = Math.round((score / totalScore) * 100);
  console.log('percentage', percentage, score, totalScore);
  const getScoreColor = () => {
    if (percentage >= 80) return "success.main";
    if (percentage >= 60) return "warning.main";
    return "error.main";
  };

  const getScoreMessage = () => {
    if (percentage >= 90) return "Excellent Work!";
    if (percentage >= 80) return "Great Job!";
    if (percentage >= 70) return "Good Effort!";
    if (percentage >= 60) return "Keep Practicing!";
    return "Need More Practice";
  };

  return (<Dialog
    open={open}
    maxWidth="sm"
    fullWidth
    onClose={onClose}
  >
    <DialogTitle
      sx={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "white",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "1.5rem",
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 60, mb: 1, display: "block", mx: "auto" }} />
      Exercise Complete!
      {(dayLabel || sectionLabel) && (
        <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9, fontWeight: 400 }}>
          {[dayLabel, sectionLabel].filter(Boolean).join(" — ")}
        </Typography>
      )}
    </DialogTitle>
    <DialogContent sx={{ pt: 4 }}>
      {score !== undefined && (
        <>
          <Box display="flex" justifyContent="center" my={3}>
            <Box
              sx={{
                width: 180,
                height: 180,
                borderRadius: "50%",
                border: `8px solid`,
                borderColor: getScoreColor(),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "grey.50",
              }}
            >
              <Box textAlign="center">
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  sx={{ color: getScoreColor() }}
                >
                  {score}/{totalScore}
                </Typography>
                {/* <Typography variant="body2" color="text.secondary">
                  Your Score
                </Typography> */}
              </Box>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-around" mb={3}>
            <Box textAlign="center">
              <Typography variant="h4" fontWeight="bold" color="success.main">
                {correctAnswers}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Correct
              </Typography>
            </Box>
            <Box textAlign="center">
              <Typography variant="h4" fontWeight="bold" color="error.main">
                {totalQuestions - correctAnswers}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Incorrect
              </Typography>
            </Box>
            <Box textAlign="center">
              <Typography variant="h4" fontWeight="bold" color="primary.main">
                {totalQuestions}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total
              </Typography>
            </Box>
          </Box>

          <LinearProgress
            variant="determinate"
            value={percentage}
            sx={{
              height: 10,
              borderRadius: 5,
              bgcolor: "grey.200",
              "& .MuiLinearProgress-bar": {
                bgcolor: getScoreColor(),
                borderRadius: 5,
              },
            }}
          />

          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            textAlign="center"
            mt={2}
          >
            Your result has been saved{dayLabel ? ` for ${dayLabel.split(" · ")[0]}` : ""} and will appear in My Progress.
          </Typography>
        </>
      )}
    </DialogContent>
    <DialogActions sx={{ p: 3, gap: 2 }}>
      <Button
        variant="outlined"
        fullWidth
        size="large"
        onClick={() => setOpenReview(true)}
        startIcon={<VisibilityIcon />}
        disabled={!sessionId}
      >
        Review Answers
      </Button>
      <Button
        variant="contained"
        fullWidth
        size="large"
        onClick={onClose}
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        Back to Exercise
      </Button>
    </DialogActions>
    
    {/* Review Answers Dialog */}
    <ReviewAnswersDialog
      open={openReview}
      onClose={() => setOpenReview(false)}
      sessionId={sessionId}
    />
  </Dialog>
  );
};

export default FinalScoreDialog;
